if (!customElements.get('elastica-dock-help')) {
  customElements.define('elastica-dock-help', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      if (!this.link) return;
      this.attempts = 0;
      this.openPending = false;
      this.openedFromDock = false;
      this.wasOpen = false;
      this.onClick = this.openChat.bind(this);
      this.onKeyDown = (event) => {
        if (event.key === ' ' && this.hasAttribute('data-chat-ready')) {
          event.preventDefault();
          this.link.click();
        }
      };
      this.link.addEventListener('click', this.onClick);
      this.link.addEventListener('keydown', this.onKeyDown);
      this.observer = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.syncChat();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.syncChat();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.retry);
      clearTimeout(this.openRetry);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.focusFrame);
      this.link?.removeEventListener('click', this.onClick);
      this.link?.removeEventListener('keydown', this.onKeyDown);
      this.openPending = false;
      this.removeAttribute('data-chat-ready');
    }

    getApi() {
      const api = window.customerHubApi;
      return typeof api?.open === 'function' ? api : null;
    }

    syncChat() {
      if (!this.isConnected) return;
      clearTimeout(this.retry);
      const ready = Boolean(this.getApi());
      const drawer = document.querySelector('.kl-hub-drawer');
      const isOpen = Boolean(drawer && !drawer.hidden && drawer.getAttribute('aria-hidden') !== 'true');
      this.toggleAttribute('data-chat-ready', ready);
      if (ready) {
        this.link.setAttribute('role', 'button');
        this.link.setAttribute('aria-haspopup', 'dialog');
        this.link.setAttribute('aria-expanded', String(isOpen));
      } else {
        this.link.removeAttribute('role');
        this.link.removeAttribute('aria-haspopup');
        this.link.removeAttribute('aria-expanded');
      }
      if (this.wasOpen && !isOpen && this.openedFromDock) {
        this.openedFromDock = false;
        this.focusFrame = requestAnimationFrame(() => {
          if (this.isConnected && this.link.getBoundingClientRect().width > 0) {
            this.link.focus({ preventScroll: true });
          }
        });
      }
      this.wasOpen = isOpen;
      if (!ready && this.attempts++ < 120) {
        this.retry = setTimeout(() => this.syncChat(), 500);
      }
    }

    openChat(event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.openPending) return;
      this.openPending = true;
      let attempts = 0;
      const tryOpen = () => {
        if (!this.isConnected) return;
        const api = this.getApi();
        if (api) {
          try {
            api.open('/chat');
            this.openedFromDock = true;
            this.openPending = false;
            this.syncChat();
            return;
          } catch {
            this.openPending = false;
            window.location.assign(this.link.href);
            return;
          }
        }
        if (attempts++ >= 16) {
          this.openPending = false;
          window.location.assign(this.link.href);
          return;
        }
        this.openRetry = setTimeout(tryOpen, 500);
      };
      tryOpen();
    }
  });
}
